import React from 'react';
import { painClose, painIntro, painPoints } from '../data/painPoints';
import { OFFER_ANCHOR } from './constants';
export function PainSection() {
  return <section className="border-y border-golf-line bg-golf-light px-4 py-4" data-id="element-92" data-mp="38vu684fcdz20">
      <div className="mx-auto max-w-4xl" data-id="element-93" data-mp="2uxm3ffvmk3ix">
        <h2 className="mb-1.5 text-center font-display text-2xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-94" data-mp="2yzqymj1q187o">
          Does This Sound Familiar?
        </h2>
        <div className="mx-auto mb-2.5 max-w-3xl space-y-0.5 text-center text-[13px] font-medium leading-snug text-golf-muted sm:text-base" data-id="element-95" data-mp="2l6j3iheflul8">
          {painIntro.map(line => <p key={line} data-id="element-96" data-mp="2bbzkrb0j8n4a">{line}</p>)}
          <p className="font-semibold text-golf-green" data-id="element-97" data-mp="2g8pyhrov76mj">{painClose}</p>
        </div>

        <div className="grid gap-2 sm:grid-cols-2" data-id="element-98" data-mp="229hv0mlo5ccj">
          {painPoints.map(point => <a key={point.title} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border-l-4 border-golf-lime bg-white p-3 shadow-sm transition-colors duration-150 ease-out hover:bg-golf-light" data-id="element-99" data-mp="278l2set19wo7">
              <h3 className="mb-1 font-head text-[14px] font-bold uppercase leading-tight text-golf-green sm:text-lg" data-id="element-100" data-mp="3nkw2qst2u9np">
                {point.title}
              </h3>
              {point.lines.map(line => <p key={line} className="mt-0.5 text-xs font-medium leading-snug text-golf-muted sm:text-sm" data-id="element-101" data-mp="hivgdiyxws6">
                  {line}
                </p>)}
            </a>)}
        </div>
      </div>
    </section>;
}